module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/caret-down-ebda70e12e33be695b12e31bebafd7ac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/caret-down.svg
// module id = miip
// module chunks = 24